import React from 'react'
import Banner from "./banner"
import Products from "./products"


function index() {
    return (
        <div className='shop'>
            <Banner />
            <Products/>
        </div>
    )
}

export default index